<template>
  <div class="product-bubble-wrapper">
    <div v-show="showBubble" class="product-bubble thead-bubble due-date-management-thead-bubble" @mouseover="handleMouseOver()" @mouseleave="handleMouseLeave()" v-html="bubbleText" />
    <div>
      有効期限
      <i class="fa fa-question-circle thead-bubble-icon"
        @mouseover="handleMouseOver()"
        @mouseleave="handleMouseLeave()"
      />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showBubble: false
    }
  },
  computed: {
    bubbleText () {
      return `有効期限がある商品か、ない商品かを選択してください。<br/>有効期限がある商品の場合、有効期限日の入力が必要となります。<br/>※有効期限をご入力いただいた場合は、オプション費用がかかります。`
    }
  },
  methods: {
    handleMouseOver () {
      this.showBubble = true
    },
    handleMouseLeave () {
      this.showBubble = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/DueDateManagementThead.vue